"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeSectionPropertiesCommandBase = void 0;
var tslib_1 = require("tslib");
var section_properties_command_base_1 = require("./section-properties-command-base");
var ChangeSectionPropertiesCommandBase = (function (_super) {
    tslib_1.__extends(ChangeSectionPropertiesCommandBase, _super);
    function ChangeSectionPropertiesCommandBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChangeSectionPropertiesCommandBase.prototype.getStateValue = function (_options) {
        return this.getCurrentValue();
    };
    ChangeSectionPropertiesCommandBase.prototype.executeCore = function (_state, options) {
        var newValue = options.param;
        if (this.getCurrentValue() != newValue) {
            this.getDescriptor().setProp(this.inputPosition.getMergedSectionPropertiesRaw(), newValue);
            var iter = this.getAffectedSectionsIterator(options.intervalsInfo.intervals);
            while (iter.moveNext())
                this.history.addAndRedo(new (this.getDescriptor().getHistoryItemConstructor())(this.modelManipulator, iter.obj.interval, newValue));
            return true;
        }
        return false;
    };
    ChangeSectionPropertiesCommandBase.prototype.getCurrentValue = function () {
        return this.getDescriptor().getProp(this.inputPosition.getMergedSectionPropertiesRaw());
    };
    return ChangeSectionPropertiesCommandBase;
}(section_properties_command_base_1.SectionPropertiesCommandBase));
exports.ChangeSectionPropertiesCommandBase = ChangeSectionPropertiesCommandBase;
